import { useEffect, useState, useContext, useRef, useCallback } from 'react';
import { getMessages, postMessage } from '../common/api-requests';
import MessagesItemTemplate from './pane-right-messages-item-template';
import './pane-right-messages.scss'
import MessagesHeader from './pane-right-messages-header';
import { AccountContext } from '../context/account-context';
import moment from 'moment';
import TextArea from 'devextreme-react/text-area';
import { Button } from 'devextreme-react/button';
import { SocketContext } from '../context/socket-context';
import { ReadContext } from '../context/read-context';
import { ErrorContext } from '../context/error-context';


export default function PaneMessages({ recipient }) {
    const [account, setAccount] = useContext(AccountContext);
    const [timeoutId, setTimeoutId] = useState(null);
    const [messages, setMessages] = useState([]);
    const [isNeedScrollBottom, setIsNeedScrollBottom] = useState(true);
    const [searchValue, setSearchValue] = useState(null);
    const [socket, setSocket] = useContext(SocketContext);
    const [read, setRead] = useContext(ReadContext);
    const [error, setError] = useContext(ErrorContext);

    const divListMessages = useRef(null);
    const txtMessage = useRef(null);
    const [isShowSpeedDialAction, setIsShowSpeedDialAction] = useState(false);


    const readMessages = (messages) => {
        let notReadIDs = messages.filter(a => !a.isRead).map(a => a.id);
        setRead(notReadIDs);
    }

    const handleSearch = useCallback((value) => {
        setSearchValue(value);
    });

    const handleLoadMoreClick = (() => {

        getMessages(recipient.id, messages.length, 20, searchValue).then((data) => {

            if (data && data.length) {
                setIsNeedScrollBottom(false);
                readMessages(data);
                setMessages([...messages, ...data].sort(function (a, b) { return new Date(a.ondate) - new Date(b.ondate) }));
            }
        });
    });

    useEffect(() => {

        getMessages(recipient.id, 0, 20, searchValue).then((data) => {

            if (data && data.length) {
                data = data.sort(function (a, b) { return new Date(a.ondate) - new Date(b.ondate) });
                readMessages(data);
            }

            setMessages(data);
        }).catch((errorInner) => {
            setError("(" + errorInner.status + ")" + " " + errorInner.text);
        });;

    }, [recipient, searchValue]);

    useEffect(() => {
        if (divListMessages.current && isNeedScrollBottom) {
            divListMessages.current.scrollTop = divListMessages.current.scrollHeight;
        }
    }, [messages]);

    useEffect(() => {

        if (!socket || socket.type !== 1)
            return;

        const messageIndex = messages.findIndex(obj => obj.id === socket.id);

        if (socket.action === 1 && socket.senderAccountID == recipient.id && messageIndex === -1) {
            readMessages([socket]);
            setMessages([...messages, socket]);
        }
        else if (socket.action == 2 && messageIndex !== -1){
            const messagesUpd = [...messages];
            messagesUpd[messageIndex] = socket;
            setMessages(messagesUpd);
        }
        else if (socket.action == 2 && messageIndex !== -1){
            setMessages(messages.filter(a=>a.id !== socket.id));
        }

    }, [socket]);

    const sendMessage = useCallback(() => {

        const text = txtMessage.current.instance.option("value");

        if (!text)
            return;

        const messageNew = {
            ondate: moment(new Date()).toISOString(),
            text: text,
            recipientAccountID: recipient.id,
            senderAccountID: account.id
        }

        postMessage(text, recipient.id).then((id) => {

            if (id) {
                txtMessage.current.instance.option("value", "");
            }
        }).catch((errorInner) => {
            setError("(" + errorInner.status + ")" + " " + errorInner.text);
        });

        setMessages([...messages, messageNew]);
    });

    const attachFiles = (files) => {

    };

    const handleAttachFile = useCallback(() => {

        window.showOpenFilePicker({
            //types: [
            //    {
            //        description: "Images",
            //        accept: {
            //            "image/*": [".png", ".gif", ".jpeg", ".jpg"],
            //        },
            //    },
            //],
            excludeAcceptAllOption: false,
            multiple: true,
        }).then(function (handles) {

            let getFiles = [];

            if (handles && handles.length) {

                for (var i = 0; i < handles.length; i++) {
                    getFiles.push(handles[i].getFile());
                }

                Promise.all(getFiles).then(files => {
                    attachFiles(files);
                });
            }
        });
    });


    const handleEnterKey = useCallback((e) => {
        if (e.event && e.event.ctrlKey) {
            sendMessage();
        }
    });

    const handleOnScroll = useCallback((e) => {
        setIsShowSpeedDialAction(divListMessages.current.offsetHeight - divListMessages.current.scrollTop > 80);
    }, [isShowSpeedDialAction]);

    const handleFloatButtonClick = (e) => {
        divListMessages.current.scrollTop = divListMessages.current.scrollHeight;
    }


    if (!account)
      return <></>


    return (

        <div className="messages-container">

            <MessagesHeader
                handleSearch={handleSearch}
            ></MessagesHeader>

            <div className="list-messages" ref={divListMessages} onScroll={handleOnScroll}>

                <button className='buttonLoadMore' style={{ display: messages.length % 20 ? 'none' : 'block' }} onClick={handleLoadMoreClick}>Раніше надіслані</button>

                {messages.map((message, index) => {

                    let daySeparatorText = '';

                    if (!messages.some(a => a.ondate && (new Date(a.ondate) < new Date(message.ondate)) && (new Date(a.ondate) > moment(message.ondate).startOf('day').toDate()))) {
                        if (moment(message.ondate).isSame(moment(), 'day')) {
                            daySeparatorText = "Сьогодні";
                        }
                        else if (moment(message.ondate).isSame(moment().subtract(1, 'day'), 'day')) {
                            daySeparatorText = "Вчора";
                        }
                        else {
                            daySeparatorText = moment(message.ondate).format('LL');
                        }
                    }

                    return (

                        <div key={index}>
                            <div className="messagesDaySeparator" style={{ display: daySeparatorText ? "inline-flex" : "none" }}>
                                <div></div>
                                <div>{daySeparatorText}</div>
                                <div></div>
                            </div>

                            <MessagesItemTemplate accountID={account.id} message={message} index={index}></MessagesItemTemplate>

                        </div>
                    )
                })}

            </div>

            <div className='sendContainer'>
                <div className='sendFilesContainer'></div>
                <div className='sendMessageContainer'>
                    <Button
                        hint="Прикріпити файл"
                        visible={false}
                        height={"100%"}
                        width={24}
                        icon={'attach'}
                        stylingMode="text"
                        activeStateEnabled={false}
                        focusStateEnabled={false}
                        hoverStateEnabled={false}
                        onClick={handleAttachFile}
                    ></Button>

                    <TextArea
                        ref={txtMessage}
                        className="sendMessageTextArea"
                        placeholder='Введіть повідомлення'
                        autoResizeEnabled={true}
                        activeStateEnabled={false}
                        focusStateEnabled={false}
                        hoverStateEnabled={false}
                        minHeight={56}

                        onEnterKey={handleEnterKey}
                    ></TextArea>

                    <Button
                        hint="Надіслати"
                        height={"100%"}
                        width={24}
                        icon="chevronright"
                        stylingMode="text"
                        activeStateEnabled={false}
                        focusStateEnabled={false}
                        hoverStateEnabled={false}

                        onClick={sendMessage}

                    ></Button>


                </div>
            </div>

            <button
                style={{ display: isShowSpeedDialAction ? "block" : "none" }}
                className="floatButton dx-icon-arrowdown"
                onClick={handleFloatButtonClick}
            ></button>

        </div>
    );
}



